import { Component, ComponentFactory, Input, OnInit, ViewChild } from "@angular/core";
import { SmallCardSvgDirective } from "@app/home/cards/small-card-svg.directive";
import { User } from "@app/shared/user";

export interface SmallCard {
  svg: ComponentFactory<any>;
  title: string;
  link: string;
  text?: string;
  details?: string;
}

@Component({
  selector: "om-small-card",
  templateUrl: "./small-card.component.html",
  styleUrls: ["../default-styling.scss", "./small-card.component.scss"],
})
export class SmallCardComponent implements OnInit {
  @Input() user: User;
  card: SmallCard;
  @ViewChild(SmallCardSvgDirective) cardSvg: SmallCardSvgDirective;

  constructor() {}

  ngOnInit() {
    const viewContainerRef = this.cardSvg.viewContainerRef;
    viewContainerRef.clear();
    viewContainerRef.createComponent(this.card.svg);
  }
}
